module.exports = __webpack_public_path__ + "img/home_logo.b1248107.png";